import LabServiceCollection from "@/collections/LabServiceCollection";
import ScheduleStatusModel from "@/models/lab/ScheduleStatusModel";

export default class ScheduleStatusCollection extends LabServiceCollection {
  model() {
    return ScheduleStatusModel;
  }

  prepareFilter(filter) {
    return filter;
  }
}
